<ng-container *ngIf="!printReport">
  <app-health-calendar-header class="header-date" [(view)]="view" [weekStartsOn]="weekStartsOn" [(viewDate)]="viewDate" (viewDateChange)="fetchEvents()" (printReport)="report($event)"></app-health-calendar-header>
  <app-health-calendar-view class="flex-body" [view]="view" [weekStartsOn]="weekStartsOn" [viewDate]="viewDate" [events]="events" [patient]="patient"></app-health-calendar-view>
</ng-container>
<ng-container *ngIf="printReport">
  <app-health-calendar-report class="flex-control flex-column" [patient]="patient" (printReport)="report($event)"></app-health-calendar-report>
</ng-container>

